import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { LIST_TAB_RANK } from "../../constants/rank";
import { GlobalLeaderboard } from "../../types/globalLeaderboards";

interface IGlobalLeaderboard {
  globalLeaderboards: GlobalLeaderboard | null;
  activeTab: string;
}

const initialState = {
  globalLeaderboards: null,
  activeTab: LIST_TAB_RANK[0],
} as IGlobalLeaderboard;

export const globalLeaderboardSlice = createSlice({
  name: "globalLeaderboards",
  initialState: initialState,
  reducers: {
    updateActiveTab: (state, action: PayloadAction<{ activeTab: string }>) => {
      state.activeTab = action.payload.activeTab;
    },
  },
});

export const { updateActiveTab } = globalLeaderboardSlice.actions;

export default globalLeaderboardSlice.reducer;
